import pRetry, { type Options as PRetryOptions } from 'p-retry'

export class NonRetryableUploadError extends Error {
  readonly status?: number
  constructor(message: string, status?: number) {
    super(message)
    this.name = 'NonRetryableUploadError'
    this.status = status
  }
}

export const DEFAULT_RETRY_OPTIONS: PRetryOptions = {
  retries: 2,
  factor: 2,
  minTimeout: 1000,
  maxTimeout: 8000,
  randomize: true,
  shouldRetry: ({ error }) => !(error instanceof NonRetryableUploadError),
}

export function withRetry<T>(
  fn: (attempt: number) => Promise<T>,
  overrides?: PRetryOptions,
): Promise<T> {
  return pRetry(fn, { ...DEFAULT_RETRY_OPTIONS, ...overrides })
}
